export { CTAColors, alertColors, neutralColors } from '../../colors/colors.js';

var brandColors = {
  primary: "#fe5000",
  secondary: "#22092b"
};

export { brandColors };
